/** Presentation-only switch shared by application configuration and standalone loading UI. */
export const PRO_APP_ENABLED = import.meta.env.VITE_ENABLE_PRO_APP === 'true'
